import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema, defaultObject} from '/vercel/path0/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/markdoc/tags/index.ts'
import * as nodes from '/vercel/path0/markdoc/nodes/index.ts'
const functions = {};
const schema = {
tags: defaultObject(tags),
nodes: defaultObject(nodes),
functions: defaultObject(functions),
...defaultObject(config),
};

const tokenizer = new Markdoc.Tokenizer();

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: \"Covalent Goes Community-led Closing $10 Million in the CoinList Public Sale\"\ndate: 2021-05-10T04:25:15-06:00\ncategories: [\"company\",\"ecosystem\"]\ndescription: \"The new public sale round will bring the Covalent Query Token, CQT, to the public for the first time as Covalent continues to move toward a community-led project.\"\nauthor: ganesh\nsubbrand_image: https://www.covalenthq.com/static/images/blog/202105/sale-cl.jpg\n\ntype: legacy\n---\n\n**VANCOUVER, May 10th, 2021** - Covalent, an indexing/querying blockchain data provider, has\nclosed $10 million from a CoinList Public Sale. The new public sale round will bring the Covalent Query Token, CQT, to the public for the first time as Covalent continues to move toward a community-led project.\n\n\n\n\nOver 3 years in the making, Covalent has come a long way. We’ve designed a world-class product that is mission-critical to over 150+ projects in the space, assembled a relentless team of crypto-natives to take the product to market globally and have now for the first time in Covalent’s history, the opportunity for the community to partake and contribute to our shared journey.\n\nWe're grateful to the community for participating in large numbers in the public sale on CoinList. It is a big milestone for us to welcome an extended family of 14,000 token holders. Our goal with the sale was to extend the reach and make Covalent community-led.\n\nSince our strategic private sale round earlier this year, we have been heads down building -- adding 3 new blockchains to our existing roster of 8 blockchains, hand-picking 1200 passionate individuals as Alchemists, running our flagship hackathons ‘One Million Wallets’ and ‘Dungeons and Data’, and launching the decentralized Covalent Network. We have been busy.\n\nThis is just the start. It’s still day 1 for the genesis team at Covalent and the broader ecosystem. We will continue the march towards bringing transparency and visibility to billions of blockchain data points with the unified Covalent API.\n\n## Summary of the Sale\n\n- Over 14,000 new token holders were added to the Covalent community, with $10M in CQT tokens purchased throughout the course of the sale\n- 3.5% of the CQT supply was dedicated to the CoinList public sale and was fully sold\n- The event drew record demand on CoinList, with almost 400,000 unique registrants. One of the options got sold out in less than 10 mins\n\nThe sale was not available in the United States, Canada, and other jurisdictions, and this announcement is not directed to anyone in those jurisdictions.\n\n## Quote from Graham Jenkin, CoinList CEO\n\n\n \n “\n Consumers of blockchain data want fast and easy access to data without the pain of dealing with individual blockchain data structure idiosyncrasies. The Covalent team gets this. We’re proud to help the Covalent team expand their community of CQT holders and incentivize validators to power their network.\n \n \n\n## Quote from Ganesh Swami, Covalent CEO\n\n\n \n “\n The overwhelming support from the community shows a growing understanding of the role that data analytics plays in powering the crypto, DeFi and NFT markets. We want to extend our gratitude to CoinList for making the public sale seamless.\n \n \n\n\n\n\n\n";
const filepath = "/blog/coinlist-sale-recap.md";
const tokens = tokenizer.tokenize(source);
const ast = Markdoc.parse(tokens);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    const tokens = tokenizer.tokenize(partials[key]);
    partials[key] = Markdoc.parse(tokens);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = await Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
